module.exports = __webpack_public_path__ + "static/img/dia-del-nino-1.09014d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/dia-del-nino-1.jpg
// module id = 7QO/
// module chunks = 1